import React from "react";
import CommonLayout from "../../../Components/CommonLayout/CommonLayout";
import BasicTable from "../../../Components/CommonTable/BasicTable/BasicTable";

const TransactionHistory = ({meta}) => {
  const columns = [
    { field: "id", header: "Id" },
    { field: "date", header: "Email" },
    { field: "date", header: "Date" },
    { field: "user_type", header: "Country" },
    { field: "currency", header: "Currency" },
    { field: "detail", header: "Amount" },
    { field: "wallet_amount", header: "	Transfer Status" },
    { field: "add_cut", header: "Transfer By" },
  ];

  const data = [];
  const searchBy = {
    filterType: "Search By",
    inputName: "search_by",
    options: [
      {
        name: "User",
        code: "User",
      },
      {
        name: "Order no",
        code: "Order no",
      },
      {
        name: "Store",
        code: "Store",
      },
    ],
  };

  const filters = [
    {
      filterType: "delivery Type",
      inputName: "delivery_type",
      options: [
        {
          name: "Delivery",
          code: "Delivery",
        },
        {
          name: "Pickup",
          code: "Pickup",
        },
        {
          name: "Schedule",
          code: "Schedule",
        },
        {
          name: "Now",
          code: "Now",
        },
      ],
    },
    {
      filterType: "Select Payment Type",
      inputName: "select_payment_type",
      options: [
        {
          name: "Cash",
          code: "Cash",
        },
        {
          name: "Paystack",
          code: "Paystack",
        },
        {
          name: "Razorpay",
          code: "Razorpay",
        },
        {
          name: "Paytabs",
          code: "Paytabs",
        },
        {
          name: "Stripe",
          code: "Stripe",
        },
        {
          name: "Paypal",
          code: "Paypal",
        },
      ],
    },
  ];

  return (
    <div className='main-content'>
      <CommonLayout />
      <BasicTable
        data={data}
        columns={columns}
        // SearchBy={searchBy}
        // filters={filters}
        WeekRange={false}
        MonthRange={false}
      />
    </div>
  );
};

export default TransactionHistory;
